<script setup>
import { createDescriptionMarkup } from "@/api/httpApi";

const props = defineProps(["checkedPrivacy", "privacyText", "id", "name"]);
defineEmits(["change"]);
</script>
<template>
  <div class="bg-light p-4 shadow-sm mt-5" aria-live="polite">
    <h2 class="h3 mb-3">Informativa sulla privacy</h2>
    <div class="bg-white p-4 mt-4">
      <p class="mb-3" v-html="createDescriptionMarkup(props.privacyText)"></p>
      <div class="form-check form-check-inline">
        <input
          :id="`${props.id}`"
          :name="props.name"
          type="checkbox"
          :checked="props.checkedPrivacy"
          class="form-check-input"
          required
          data-yup-label="Privacy"
          @change="
            (e) => {
              $emit('change', e.target.checked);
            }
          "
        />
        <label for="checkboxPrivacy">Ho letto e compreso l'informativa sulla privacy</label>
      </div>
    </div>
  </div>
</template>
